<template>
  <div>
    <v-label v-if="label">{{ label }}</v-label>

    <ckeditor
      :editor="editor"
      v-model="content"
      :config="editorConfig"
    />
  </div>
</template>

<script>
  import ClassicEditor from '../plugins/ckeditor5/build/ckeditor';
  
  export default {
    name: "wysiwyg",

    props: {
      'label': String,
      'value': String,
    },

    computed: {
      content: {
        get() { return this.value != null ? this.value : "" },
        set(content) {this.$emit('input', content)}
      }
    },

    data: () => {
      return {
        editor: ClassicEditor,
        editorConfig: {
          toolbar: [
            'undo',
            'redo',
            '|',
            'bold',
            'italic',
            'underline',
            '|',
            'alignment:left',
            'alignment:center',
            'alignment:right',
            'alignment:justify',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'indent',
            'outdent'
          ],
        },
      }
    },
  }
</script>